export enum EntityItemLayoutEnum {
  GRID = 'grid',
  ROW = 'row'
}
